module.exports = {"key":"hello italian","submit":"Dicci cosa ne pensi","hide":"Nascondi    ","skip":"Passa alla prossima domanda","placeholder":"Per piacere dicci come ti senti a riguardo..."}


//////////////////
// WEBPACK FOOTER
// ./src/translations/it.json
// module id = 445
// module chunks = 0